import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    description: string;
    enabledDescription: string;
    error: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title for the project access toggle */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAccessToggle.title?c=rh3djn0viyad", defaultMessage: "Make Restricted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for the project access toggle */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAccessToggle.description?c=2gx12ae5qn1fq", defaultMessage: "Only people directly invited to the project will have access, plus admins." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description for the project access toggle when it is enabled */
            enabledDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAccessToggle.enabledDescription?c=2zb6hhs7k5gnl", defaultMessage: "Only people directly invited to the project can access, plus admins." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message for the project access toggle */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectAccessToggle.error?c=3hysb3djkf1u6", defaultMessage: "Something went wrong" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
